// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2mPbY","label":"Completed_label__1X1gf"};